import { render, staticRenderFns } from "./offlineDetail.vue?vue&type=template&id=6116be9d&"
import script from "./offlineDetail.vue?vue&type=script&lang=js&"
export * from "./offlineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports